import React from 'react'
import CreateItemDetails from '../../components/itemdetailscomponents/CreateItemDetails'

function ItemDetailsRegister({renderPageContent}) {
    return (
        <>
                        <CreateItemDetails renderPageContent={renderPageContent}/>
        </>
    )
}

export default ItemDetailsRegister
